import apiClient from '../apiClient';
import { GET_RESTAURANT_ITEM_BY_PROFILE_ID_URL } from '../apiUrl';

const getRestaurantItemByProfileIdApi = Id => {
  return apiClient.get(GET_RESTAURANT_ITEM_BY_PROFILE_ID_URL(Id));
};

export default getRestaurantItemByProfileIdApi;
